// React
import React from "react";
// isMobile
import isMobile from "ismobilejs";
// Router
import { Route, Switch, Redirect } from "react-router-dom";
// Redux
import { connect } from "react-redux";
// UI
import { withStyles } from "material-ui/styles";
// API
import api from "api";
// Container
import HeaderContainer from "containers/HeaderContainer";
import LoginContainer from "containers/Login/LoginContainer";
import CustomerListContainer from "containers/CustomerList/CustomerListContainer";
import CustomerDetailContainer from "containers/CustomerDetail";
import AdminListContainer from "containers/AdminList/AdminListContainer";
import SurveyDetailContainer from "containers/SurveyDetail/SurveyDetailContainer";
import SurveyProgressContainer from "containers/SurveyProgress/SurveyProgressContainer";
import SurveyListContainer from "containers/SurveyList/SurveyListContainer";
import CreateSurveyBaseInfo from "containers/CreateSurvey/BaseInfo";
import CreateSurveySelectAttr from "containers/CreateSurvey/SelectAttr";
import CreateSurveyBaseWord from "containers/CreateSurvey/BaseWord";
import CreateSurveyAdditions from "containers/CreateSurvey/Additions";
import SetupAttr from "containers/SetupAttr";
import NoMatchContainer from "containers/NoMatchContainer";
import SendResetPassword from "containers/SendResetPassword";
import PasswordResetContainer from "containers/PasswordResetContainer";
import PasswordUpdateContainer from "containers/PasswordUpdateContainer";
import ManualDownloadContainer from "containers/ManualDownloadContainer";
import SurveyCheckWordContainer from "containers/SurveyCheckWordContainer";
import ReportContainer from "containers/Report/ReportContainer";
import ReportDetailContainer from "containers/ReportDetail/ReportDetailContainer";
import BasicReportContainer from "containers/ReportDetail/BasicReportContainer";
import OriginalReportContainer from "containers/ReportDetail/OriginalReportContainer";
import ResultIndexReportContainer from "containers/ReportDetail/ResultIndexReportContainer";
import FreeOpinionReportContainer from "containers/ReportDetail/FreeOpinionReportContainer";

// Container(Answer)
import AnswerSurveyLoginContainer from "containers/answer/SurveyLoginContainer";
import AnswerReportLoginContainer from "containers/answer/ReportLoginContainer";
import AnswerStartContainer from "containers/answer/AnswerStartContainer";
import AnswerHeaderContainer from "containers/answer/AnswerHeaderContainer";
import AttributeReadyContainer from "containers/answer/AttributeReadyContainer";
import AnswerAttributeContainer from "containers/answer/AnswerAttributeContainer";
import QuestionReadyContainer from "containers/answer/QuestionReadyContainer";
import AnswerQuestionContainer from "containers/answer/AnswerQuestionContainer";
import AnswerOtherContainer from "containers/answer/AnswerOtherContainer";
import AnswerResultContainer from "containers/answer/AnswerResultContainer";
import AnswerCompleteContainer from "containers/answer/AnswerCompleteContainer";
// Container(Preview)
import PreviewAnswerStartContainer from "containers/preview/AnswerStartContainer";
import PreviewAnswerHeaderContainer from "containers/preview/AnswerHeaderContainer";
import PreviewAttributeReadyContainer from "containers/preview/AttributeReadyContainer";
import PreviewAnswerAttributeContainer from "containers/preview/AnswerAttributeContainer";
import PreviewQuestionReadyContainer from "containers/preview/QuestionReadyContainer";
import PreviewAnswerQuestionContainer from "containers/preview/AnswerQuestionContainer";
import PreviewAnswerOtherContainer from "containers/preview/AnswerOtherContainer";
import PreviewAnswerResultContainer from "containers/preview/AnswerResultContainer";
import PreviewAnswerCompleteContainer from "containers/preview/AnswerCompleteContainer";
// 共通
import ErrorDialogContainer from "containers/ErrorDialogContainer";
import MessageDialogContainer from "containers/MessageDialogContainer";
import ConfirmDialogContainer from "containers/ConfirmDialogContainer";
import SnackbarContainer from "containers/SnackbarContainer";
import CompleteDialogContainer from "containers/CompleteDialogContainer";
// Action
import { setLoginInfo } from "redux/modules/header";
import { openErrorDialog } from "redux/modules/errorDialog";
// utils
import { pathRole, isAnswer, isPreview } from "utils/formatter";
import history from "utils/history";
import storage from "utils/storage";
// Highchartsのoption読み込み
import ReactHighcharts from "react-highcharts";
import More from "highcharts/highcharts-more";
import Grouped from "highcharts-grouped-categories";
import Overlapping from "highcharts/modules/overlapping-datalabels";

More(ReactHighcharts.Highcharts);
Overlapping(ReactHighcharts.Highcharts);
Grouped(ReactHighcharts.Highcharts);

const styles = {
  mainOuter: {
    width: 1300,
    margin: "auto",
    paddingBottom: 10,
    wordBreak: "break-all",
    whiteSpace: "pre-line"
  }
};

const mobileStyle = {
  mainOuter: {
    paddingBottom: 10,
    wordBreak: "break-word",
    whiteSpace: "pre-line"
  },
  pseudobody: {
    /* Androidでプルダウンリフレッシュを無効にする設定 */
    width: "100%",
    height: "100%",
    position: "absolute",
    top: 0,
    zIndex: 2,
    margin: 0,
    padding: 0,
    overflowY: "auto"
  }
};

class App extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      isAuthenticated: false,
      noMatch: false
    };
  }

  componentWillMount() {
    // Androidでプルダウンリフレッシュを無効にする設定
    if (isMobile.android.device) {
      document.body.style.cssText = `
        width: 100%;
        height: 100%;
        display: block;
        position: absolute;
        top: -1px;
        z-index: 1;
        margin: 0;
        padding: 0;
        overflow-y: hidden;
      `;
    }

    // リロードした場合や、ロールを変更してアクセスした場合の処理
    if (this.props.history.location.pathname === "/") {
      this.setState({ isAuthenticated: true });
    } else if (pathRole() === null) {
      this.setState({ noMatch: true });
    } else if (this.beforeLogin()) {
      // ログイン画面を表示した場合は認証しない
      this.setState({ isAuthenticated: true });
    } else if (isAnswer()) {
      // ログイン画面へ戻す
      const surveyId = storage.getSurveyId("surveyId");
      if (surveyId) {
        this.props.historyPush(`/login/survey/${surveyId}/${storage.getUrlToken()}`);
        storage.removeSurveyId("surveyId");
      } else {
        this.props.historyPush(`/login/survey/${storage.getUrlToken()}`);
      }
      window.location.reload();
    } else if (isPreview()) {
      if (
        this.props.history.location.pathname.indexOf("/preview/start/") > -1
      ) {
        // プレビューの開始画面では認証する
        api
          .get("auth")
          .then(() => {
            this.setState({ isAuthenticated: true });
          })
          .catch(error => this.props.openErrorDialog(error));
      } else {
        // 開始画面へ戻す
        this.props.historyPush(`/start/${storage.getPreviewSurveyId()}`);
        window.location.reload();
      }
    } else {
      // ログイン後の画面を表示した場合に認証する
      api
        .get("auth")
        .then(res => {
          this.setState({ isAuthenticated: true });
          this.props.setLoginInfo(res.loginInfo);
        })
        .catch(error => this.props.openErrorDialog(error));
    }
  }

  // 現在の画面がログイン前の画面かどうかの判定
  beforeLogin() {
    const currentPath = this.props.location.pathname;

    const isRoot = currentPath === "/";
    const paths = ["/login", "/send_reset_password", "/password_reset/"];
    const path = paths.find(_path => currentPath.indexOf(_path) > -1);

    const customerAdminPaths = ["/customer_admin", "/customer_admin/"];
    const ustomerAdminPath = customerAdminPaths.find(
      _path => currentPath === _path
    );

    return isRoot || path !== undefined || ustomerAdminPath;
  }

  render() {
    const { classes } = this.props;

    return (
      <div className={isMobile.android.device ? classes.pseudobody : ""}>
        {/* 共通のエラーダイアログ */}
        <ErrorDialogContainer />

        {/* 完了ダイアログ */}
        <CompleteDialogContainer />

        {/* 共通の確認ダイアログ */}
        <ConfirmDialogContainer />

        {/* 共通のメッセージダイアログ */}
        <MessageDialogContainer />

        {/* 共通のスナックバー */}
        <SnackbarContainer />

        {/* 認証後に表示 */}
        {this.state.isAuthenticated && (
          <div>
            {/* ログイン画面でなければヘッダーを表示 */}
            {!this.beforeLogin() &&
              pathRole() !== "answer" && <HeaderContainer />}

            {!this.beforeLogin() &&
              pathRole() === "answer" && <AnswerHeaderContainer />}

            {!this.beforeLogin() &&
              pathRole() === "preview" && <PreviewAnswerHeaderContainer />}

            <div className={classes.mainOuter}>
              <Switch>
                {/* ルーター */}
                <Redirect exact from="/" to="/customer_admin" />
                <Route
                  path="/answer/login/survey/:id/:urlToken"
                  component={AnswerSurveyLoginContainer}
                />
                <Route
                  path="/answer/login/survey/:urlToken"
                  component={AnswerSurveyLoginContainer}
                />
                <Route
                  path="/answer/login/report/:urlToken"
                  component={AnswerReportLoginContainer}
                />

                <Route path="/admin/login" component={LoginContainer} />
                <Route
                  exact
                  path="/customer_admin"
                  component={LoginContainer}
                />
                <Route
                  path="/admin/customer_list"
                  component={CustomerListContainer}
                />
                <Route
                  path="/:role/customer/:id"
                  component={CustomerDetailContainer}
                />
                <Route
                  path="/admin/admin_list"
                  component={AdminListContainer}
                />
                <Route
                  path="/:role/survey_list"
                  component={SurveyListContainer}
                />
                <Route path="/:role/setup_attr/:id" component={SetupAttr} />
                <Route
                  path="/:role/survey_detail/:id"
                  component={SurveyDetailContainer}
                />
                <Route
                  path="/:role/survey_progress/:id"
                  component={SurveyProgressContainer}
                />
                <Route
                  path="/:role/create_survey/:id/base_info"
                  component={CreateSurveyBaseInfo}
                />
                <Route
                  path="/:role/create_survey/:id/select_attr"
                  component={CreateSurveySelectAttr}
                />
                <Route
                  path="/:role/create_survey/:id/base_word"
                  component={CreateSurveyBaseWord}
                />
                <Route
                  path="/:role/create_survey/:id/additions"
                  component={CreateSurveyAdditions}
                />
                <Route
                  path="/:role/edit_survey/:id/base_info"
                  component={CreateSurveyBaseInfo}
                />
                <Route
                  path="/:role/edit_survey/:id/select_attr"
                  component={CreateSurveySelectAttr}
                />
                <Route
                  path="/:role/edit_survey/:id/base_word"
                  component={CreateSurveyBaseWord}
                />
                <Route
                  path="/:role/edit_survey/:id/additions"
                  component={CreateSurveyAdditions}
                />
                <Route path="/:role/report/:id" component={ReportContainer} />
                <Route
                  exact
                  path="/:role/report_detail/:id"
                  component={ReportDetailContainer}
                />
                <Route
                  exact
                  path="/:role/basic_report/:id"
                  component={BasicReportContainer}
                />
                <Route
                  exact
                  path="/:role/original_report/:id"
                  component={OriginalReportContainer}
                />
                <Route
                  exact
                  path="/:role/result_index_report/:id"
                  component={ResultIndexReportContainer}
                />
                <Route
                  exact
                  path="/:role/free_opinion_1_report/:id"
                  component={FreeOpinionReportContainer}
                />
                <Route
                  exact
                  path="/:role/free_opinion_2_report/:id"
                  component={FreeOpinionReportContainer}
                />
                <Route
                  path="/:role/send_reset_password"
                  component={SendResetPassword}
                />
                <Route
                  path="/:role/password_reset/:reset_token"
                  component={PasswordResetContainer}
                />
                <Route
                  path="/:role/password_update"
                  component={PasswordUpdateContainer}
                />
                <Route
                  path="/:role/manual_download"
                  component={ManualDownloadContainer}
                />

                <Route
                  path="/:role/survey_check_word/:id"
                  component={SurveyCheckWordContainer}
                />

                {/* 回答者 */}
                <Route
                  exact
                  path="/answer/start"
                  component={AnswerStartContainer}
                />
                <Route
                  path="/answer/attribute_ready"
                  component={AttributeReadyContainer}
                />
                <Route
                  path="/answer/answer_attribute"
                  component={AnswerAttributeContainer}
                />
                <Route
                  path="/answer/question_ready"
                  component={QuestionReadyContainer}
                />
                <Route
                  path="/answer/answer_question"
                  component={AnswerQuestionContainer}
                />
                <Route path="/answer/other" component={AnswerOtherContainer} />
                <Route
                  path="/answer/result"
                  component={AnswerResultContainer}
                />
                <Route
                  path="/answer/complete"
                  component={AnswerCompleteContainer}
                />

                {/* プレビュー */}
                <Route
                  path="/preview/start/:surveyId"
                  component={PreviewAnswerStartContainer}
                />
                <Route
                  path="/preview/attribute_ready"
                  component={PreviewAttributeReadyContainer}
                />
                <Route
                  path="/preview/answer_attribute"
                  component={PreviewAnswerAttributeContainer}
                />
                <Route
                  path="/preview/question_ready"
                  component={PreviewQuestionReadyContainer}
                />
                <Route
                  path="/preview/answer_question"
                  component={PreviewAnswerQuestionContainer}
                />
                <Route
                  path="/preview/other"
                  component={PreviewAnswerOtherContainer}
                />
                <Route
                  path="/preview/result"
                  component={PreviewAnswerResultContainer}
                />
                <Route
                  path="/preview/complete"
                  component={PreviewAnswerCompleteContainer}
                />

                {/* 一致なし */}
                <Route component={NoMatchContainer} />
              </Switch>
            </div>
          </div>
        )}

        {this.state.noMatch && <Route component={NoMatchContainer} />}
      </div>
    );
  }
}

const mapDispatchToProps = (dispatch, ownProps) => ({
  setLoginInfo: loginInfo => dispatch(setLoginInfo(loginInfo)),
  openErrorDialog: error => dispatch(openErrorDialog(error)),
  historyPush: path => history.push(path, ownProps)
});

export default connect(state => state, mapDispatchToProps)(
  withStyles(isMobile.any && (isAnswer() || isPreview()) ? mobileStyle : styles)(App)
);



// WEBPACK FOOTER //
// ./src/App.js